import EventOfflineDialog from './EventOfflineDialog';

export default EventOfflineDialog;
